'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal, Spinner } from '@common/components';
import { BREAKPOINTS, useBodyScrollLock } from '@common/hooks';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { DesktopSkeletonCover } from '@/components/organism/DesktopSkeletonCover';
import { MobileSkeletonCover } from '@/components/organism/MoblieSkeletonCover';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface LoadingPageTemplateProps {
  blur?: boolean;
  fadeIn?: boolean;
  unmountedPlaceholder?: boolean;
  className?: string;
}
export const LoadingPageTemplate = t0 => {
  const $ = _c(16);
  const {
    blur: t1,
    fadeIn,
    unmountedPlaceholder,
    className
  } = t0;
  const blur = t1 === undefined ? false : t1;
  useBodyScrollLock(true);
  const pathname = usePathname();
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const [isMounted, setIsMounted] = useState(false);
  const type = (pathname?.startsWith("/donation") ?? false) && isDesktopViewport ? "full" : "wello";
  let t2;
  if ($[0] !== blur || $[1] !== className || $[2] !== fadeIn || $[3] !== isMounted || $[4] !== type || $[5] !== unmountedPlaceholder) {
    t2 = unmountedPlaceholder && !isMounted ? <Loading type={type} blur={blur} fadeIn={fadeIn} className={className} /> : null;
    $[0] = blur;
    $[1] = className;
    $[2] = fadeIn;
    $[3] = isMounted;
    $[4] = type;
    $[5] = unmountedPlaceholder;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsMounted(true);
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== blur || $[9] !== className || $[10] !== fadeIn || $[11] !== type) {
    t4 = <Portal renderTo={getMainWrapperElement} onLoaded={t3}><Loading type={type} blur={blur} fadeIn={fadeIn} className={className} /></Portal>;
    $[8] = blur;
    $[9] = className;
    $[10] = fadeIn;
    $[11] = type;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
const Loading = t0 => {
  const $ = _c(11);
  const {
    type,
    fadeIn,
    className,
    blur
  } = t0;
  let t1;
  if ($[0] !== blur || $[1] !== className || $[2] !== fadeIn) {
    t1 = cn("fixed inset-0 z-40 flex overflow-hidden", {
      "animate-fade duration-300 animate-delay-200": fadeIn,
      "z-50": blur
    }, className);
    $[0] = blur;
    $[1] = className;
    $[2] = fadeIn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== blur || $[5] !== type) {
    t2 = blur ? <div className="absolute z-10 size-full bg-Gray-black/60" /> : type === "full" ? <DesktopSkeletonCover /> : <MobileSkeletonCover />;
    $[4] = blur;
    $[5] = type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute z-30 size-full flex-center"><Spinner logo={true} color="white" size={80} /></div>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};